import ListMenu from 'penta-components/base/listMenu';
import ListView from 'penta-components/base/listView';
import Modal from 'penta-components/base/modal';
import Separator from 'penta-components/base/separator';
import Button from 'penta-components/controls/button';
import Search from 'penta-components/controls/search';
import Select from 'penta-components/controls/select';
import { planAccountActionFailed, planAccountDeleteRequest, planAccountGetAllRecordsRequest, planAccountListSelectAllItem, planAccountListSelectItem } from 'penta-redux/actions/accountantActions';
import React, { useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import history from '../../../utils/history';
import './planAccount.scss';

const moment = require('moment');

const header = [
    { title: 'Cuentas', key: 'accaccou' },
    { title: 'Denominacion', key: 'denomina' },
    { title: 'Tipo Cuenta', key: 'codactyp' },
    { title: 'Destino-Cargo', key: 'chargacc' },
    { title: 'Destino-Abono', key: 'credtacc' },
    { title: 'Cuenta mayor', key: 'majoracc' },
    { title: 'Nivel de cuenta', key: 'acclevel' },
    { title: 'Numero de descendientes', key: 'descnumb' }
]; 

const useStyles =  createUseStyles({
    container: {
        overflow: 'auto', 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column'
    },
    titleContainer: {
        flex: 1, 
        display: 'flex', 
        alignItems: 'baseline'
    },
    title: {
        fontFamily: '"Open Sans", sans-serif', 
        fontSize: '1.563rem', 
        fontWeight: 'bold', 
        color: '#0060A6', 
        marginRight: '3rem'
    },
    tabActive: {},
    tabs: {
        margin: '0 0.4rem', 
        padding: '0.4rem 0.5rem', 
        color: '#b9b9b9', 
        fontFamily: '"Open Sans", sans-serif', 
        fontWeight: 'bold', 
        fontSize: '0.875rem',
        cursor: 'pointer',
        '&$tabActive': {
            color: '#3B3B3B',
            borderBottom: '0.2rem solid #3B3B3B', 
        }
    },
    listContainer: {
        flex: 1,
        '& > div:first-child': {
            display: 'flex'
        }
    }
});

const ListPlanAccount = (props: any) => {
    const classes = useStyles();
    const amountJump = 20;
    const [showModal, setShowModal] = React.useState(false);
    const [typeModal, setTypeModal] = React.useState('');
    //===============================================================
    const [searchValue, setSearchValue] = React.useState('');
    const [fiscyear, setFiscyear] = React.useState(moment().format('YYYY'));
    const [take, setTake] = React.useState(amountJump);
    //===============================================================
    const [typing, setTyping] = React.useState(null);
    //===============================================================

    const agregar = () => {
        history.push('/papp/accounting/plan-cuentas/agregar');
    };

    const editar = () => {
        const select = props.accountantReducers.list.find((x: any) => x.select);
        if (select !== undefined)
            history.push('/papp/accounting/plan-cuentas/editar/' + select.accaccou + '/' + select.fiscyear);
        else
            props.usersActionFailed('Error: 0x0', 'No se ha selecionado un elemento para modificar');
    }

    const eliminar = () => {
        const select = props.accountantReducers.list.filter((x: any) => x.select);
        const selectAccaccous = select.map((x: any) => { return x.accaccou });
        const selectFiscyears = select.map((x: any) => { return x.fiscyear });
        if(select.length !== 0) {
            props.planAccountDeleteRequest(selectAccaccous, selectFiscyears);
            handleCloseModal();
        }
        else
            props.planAccountActionFailed('Error: 0x0', 'No se ha selecionado un elemento para eliminar');
    }

    const handleShowModal = (typeModal: string) => {
        setShowModal(true);
        setTypeModal(typeModal);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setTypeModal('');
    };

    const onChangeSearchValue = (e) => {
        const text = e.target.value;
        setSearchValue(text);
        if(typing) clearTimeout(typing)
        setTyping(
            setTimeout(() => {
                onSearch(text);
            }, 500)
        )
    }

    const onSearch = (typing?: string) => {
        const body = {
            fields: {
                accaccou: `${typing ?? searchValue}`,
                denomina: `${typing ?? searchValue}`
            },
            skip: 0,
            take: amountJump
        } as any

        body.fiscyear = fiscyear;

        props.planAccountGetAllRecordsRequest(body);
        setTake(amountJump);
    }

    const callMoreItems = () => {
        const body = {
            fields: {
                accaccou: searchValue,
                denomina: searchValue
            },
            skip: 0,
            take: take + amountJump
        } as any

        body.fiscyear = fiscyear;

        props.planAccountGetAllRecordsRequest(body);
        setTake(take + amountJump);
    }

    useEffect(() => {
        const { planAccountGetAllRecordsRequest } = props;
        const body = {
            skip: 0,
            take
        } as any

        body.fiscyear = fiscyear;

        planAccountGetAllRecordsRequest(body);
    }, []);

    return (
        <div className={classes.container}>
            <div className={classes.titleContainer}>
                <div className={classes.title}>Plan de cuentas</div>
                <div>
                    <span className={`${classes.tabs} ${classes.tabActive}`}>Lista</span>
                    <span className={classes.tabs}>Chart</span>
                    <span className={classes.tabs}>Historial</span>
                </div>
            </div>
            <div className={classes.listContainer}>
                <div>
                    <Search styleContainer={{flex: 1}} onChange={onChangeSearchValue} value={searchValue}/>
                    <Select label="Año" labelPosition="left" style={{marginLeft: '1rem'}} data={
                        [{id: '2026', name: '2026'}, {id: '2025', name: '2025'}, {id: '2024', name: '2024'}, {id: '2023', name: '2023'}, {id: '2022', name: '2022'}, {id: '2021', name: '2021'}, {id: '2020', name: '2020'}, {id: '2019', name: '2019'}]
                    } value={fiscyear} onChange={(value) => setFiscyear(value.id)}/>
                    {/* <Select label="Mes" labelPosition="left" style={{marginLeft: '1rem'}} data={months} value={acpemont} onChange={(value) => setAcpemont(value.id)}/>
                    <Select label="Moneda" labelPosition="left" style={{marginLeft: '1rem'}} data={
                        [{id: '00', name: '--Todos--'}, {id: '00000014', name: 'Soles'}, {id: '00000015', name: 'Dolares'}]
                    } value={state} onChange={(value) => setCurrency(value.id)}/> */}
                    &nbsp;&nbsp;
                    <Button type='primary' full={false} containerStyle={{height: 'auto'}} onClick={() => onSearch()}>Filtrar</Button>
                </div>
                <Separator marginBottom='1rem'/>
                <ListMenu
                    addItem={agregar}
                    editItem={editar}
                    deleteItem={() => handleShowModal('D')}
                />
                <Separator marginBottom='0.5rem'/>
                <ListView
                    header={header} body={props.accountantReducers.list}
                    selectAction={props.planAccountListSelectItem} 
                    selectAllAction={props.planAccountListSelectAllItem}
                    total={props.accountantReducers.total}
                    callMoreItems={callMoreItems}
                />
            </div>
            {
                showModal && typeModal === 'D' &&
                <Modal 
                    title="Penta ERP"
                    onClose={() => setShowModal(false)}
                    footer={
                        <React.Fragment>
                            <Button type='bad' full={false} onClick={handleCloseModal}>Cancelar</Button>
                            &nbsp;&nbsp;
                            <Button full={false} onClick={eliminar}>Aceptar</Button>
                        </React.Fragment>
                    }
                >
                    <React.Fragment>
                        <p>¿Desea eliminar los siguientes elemetos?</p>
                        {
                            props.accountantReducers.list.filter((x: any) => x.select).map(item =>
                                <ul key={`${item.accaccou}-${item.fiscyear}`} style={{margin: '1rem 2rem'}}>
                                    <li>{item.accaccou}-{item.fiscyear}</li>
                                </ul>
                            )
                        }
                    </React.Fragment>
                </Modal>
            }
        </div>
    );
}

const accountantReducers = 'accountantReducers';
const dashboardReducers = 'dashboardReducers';

const mapStateToProps = (state: any) => ({
    accountantReducers: state.get(accountantReducers),
    dashboardReducers: state.get(dashboardReducers)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
    return bindActionCreators({
        planAccountGetAllRecordsRequest,
        planAccountListSelectItem,
        planAccountListSelectAllItem,
        planAccountActionFailed,
        planAccountDeleteRequest
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ListPlanAccount);